import { BrowserRouter } from 'react-router';
import { useSetTitle } from '@/hooks/use-set-title';
import { RouterNavigationProvider } from '@/hooks/use-navigation/router-navigation';
import { AppRoutes } from '@/routes';

export default function SpaPage() {
  useSetTitle('');

  return (
    <BrowserRouter>
      <RouterNavigationProvider>
        <AppRoutes />
      </RouterNavigationProvider>
    </BrowserRouter>
  );
}
